VIV.behaviours.submenu = (function () {
    const attach = function (context) {
        const baseClass = 'submenu';
        context.querySelectorAll(`.${baseClass}`).forEach(element => {
            initTabs(element);
            initNiv2(element);
            initNiv3(element);
        });
    };

    const initTabs = function (menu) {
        const tabs = menu.querySelectorAll('.tab');
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', function (event) {
                event.preventDefault();

                // Handle active class on item
                tabs.forEach(tab => {
                    tab.classList.remove('tab--active');
                });
                tab.classList.add('tab--active');

                // Display corresponding submenu
                const submenu = menu.querySelector('.submenu__content');
                if (submenu) {
                    for (let tab of submenu.children) {
                        tab.classList.remove('submenu__tab--active');
                    }
                    submenu.children[index].classList.add('submenu__tab--active');
                    submenu.children[index].querySelectorAll('.submenuLinks__link--active, .submenu__subtab--active').forEach(item => {
                        item.classList.remove('submenuLinks__link--active');
                        item.classList.remove('submenu__subtab--active');
                    });
                }
            });
        });

        if (menu.querySelectorAll('.tab--active').length === 0 && tabs.length > 0) {
            tabs[0].click();
        }
    };

    const initNiv2 = function (menu) {
        // Run menu item loop per tab so index is correct
        menu.querySelectorAll('.submenu__tab').forEach(tab => {

            // Get all submenu items for this tab
            const niv2links = tab.querySelectorAll('.submenu__niv2 .submenuLinks__link');
            niv2links.forEach((link, index) => {
                link.addEventListener('click', function (event) {
                    if (link.classList.contains('submenuLinks__link--withChildren')) {
                        event.preventDefault();

                        // Handle active class on item
                        niv2links.forEach(link => {
                            link.classList.remove('submenuLinks__link--active');
                            link.parentElement.classList.remove('submenuLinks__item--active');
                        });
                        link.classList.add('submenuLinks__link--active');

                        // Display corresponding submenu
                        const submenu = link.closest('.submenu__tab').querySelector('.submenu__niv3');
                        if (submenu) {
                            for (let subtab of submenu.children) {
                                subtab.classList.remove('submenu__subtab--active');
                            }
                            submenu.children[index].classList.add('submenu__subtab--active');
                            submenu.children[index].querySelectorAll('.submenuLinks__link--active, .submenu__subtab--active').forEach(item => {
                                item.classList.remove('submenuLinks__link--active');
                                item.classList.remove('submenu__subtab--active');
                            });
                        }
                    }
                });
            });

            // if (tab.querySelectorAll('.submenu__niv2 .submenuLinks__link--active').length === 0 && niv2links.length > 0) {
            //     niv2links[0].click();
            // }
        });
    };

    const initNiv3 = function (menu) {
        // Run menu item loop per tab so index is correct
        menu.querySelectorAll('.submenu__subtab').forEach(tab => {

            // Get all submenu items for this tab
            const niv3links = tab.querySelectorAll('.submenu__subtabLeft .submenuLinks__link');
            niv3links.forEach((link, index) => {
                link.addEventListener('click', function (event) {
                    if (link.classList.contains('submenuLinks__link--withChildren')) {
                        event.preventDefault();

                        // Handle active class on item
                        niv3links.forEach(link => {
                            link.classList.remove('submenuLinks__link--active');
                            link.parentElement.classList.remove('submenuLinks__item--active');
                        });
                        link.classList.add('submenuLinks__link--active');

                        // Display corresponding submenu
                        const submenu = link.closest('.submenu__subtab').querySelector('.submenu__subtabRight');
                        if (submenu) {
                            for (let subtab of submenu.children) {
                                subtab.classList.remove('submenu__subtab--active');
                            }
                            submenu.children[index].classList.add('submenu__subtab--active');
                        }
                    }
                });
            });

            tab.parentElement.classList.toggle('submenu__niv3--withNiv4', tab.querySelector('.submenu__subtabLeft') !== null);
            // if (niv3links.length > 0 && tab.querySelectorAll('.submenu__subtabLeft .submenuLinks__link--active').length === 0) {
            //     niv3links[0].click();
            // }
        });
    };

    return {
        attach: attach
    }
})();
